import React from 'react';
import { Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';

const PanelNotice = (props) => {
  return (
    <Panel.Body>
      <Panel className="panel-default dashed-border py-4 text-center">
        <Panel.Body>
          {props.children}
        </Panel.Body>
      </Panel>
    </Panel.Body>
  );
};

PanelNotice.propTypes = {
  children: PropTypes.node.isRequired
};

export default PanelNotice;
